import React from 'react';
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';
import remarkDirective from 'remark-directive';
import gfm from 'remark-gfm';
import {ShortcodesRenderer} from '../../helpers/shortcodes-renderer';
import {Prism} from 'react-syntax-highlighter';

const Container = styled.div`
  ul, ol {
    padding: revert;
    margin: revert;
    list-style: revert;
  }

  blockquote {
    border-left: .25em solid #dfe2e5;
    padding: 0 1em 0 2em;
    margin-top: 2em;
    margin-bottom: 2em;
    font-style: italic;
  }

  h1 {
    font-size: 2em;
  }

  h2 {
    font-size: 1.5em;
  }

  h3 {
    font-size: 1.17em;
  }

  h4 {
    font-size: 1em;
  }

  h5 {
    font-size: 0.83em;
  }

  h6 {
    font-size: 0.67em;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: revert;
  }

  table, th, td {
    border: 1px solid black;
    border-collapse: collapse;
  }

  p {
    margin-bottom: 1em;
  }

  td, th {
    padding: 0.4em;
  }

  code {
    padding: .2em .4em;
    margin: 0;
    font-size: 85%;
    background-color: rgba(27, 31, 35, 0.05);
    border-radius: 6px;
  }

  img[alt$=">"] {
    float: right;
  }

  img[alt$="<"] {
    float: left;
  }
`;

export const Markdown = (props: {
  children?: string
}): JSX.Element => {
  return (
    <Container>
      <ReactMarkdown plugins={[remarkDirective as any, gfm]} components={{
        leafDirective: data => ShortcodesRenderer(data),
        code: function SyntaxHighlighter({language, value}: {language: string, value: string}) { return <Prism language={language}>{value}</Prism>;}
      }}>{props.children ?? ''}</ReactMarkdown>
    </Container>
  );
};
